import { Component, OnInit } from '@angular/core';
import { ReportService, AuthenticationService, SpinnerService, DealerService } from '../services';
import { first, map } from 'rxjs/operators';
import{Angular2Csv} from 'angular2-csv'
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
  //selector: 'client-files-postage-tracking-report',
  templateUrl: 'client-files-postage-tracking-report.component.html',
  //styleUrls: ['styles.scss']
})
export class ClientFilesPostageTrackingReportComponent implements OnInit {
  toggleClass: string;
  show: boolean = false;

  dataGapCol:any;
  dataGapList:any;

  customMessage: any;
  subscribers: any;
  subscriberCols: Object;
  searchText: any = "";
  client: any = 'All';
  oem:any='All';
  clients: any;

  constructor(
    private dealerService: DealerService,
    private reportService: ReportService,    
    private spinnerService: SpinnerService,
    private http: HttpClient,
    private router: Router
    ) { }

  ngOnInit(): void {
    
    // this.getClients(); 
    this.getClientFilePostageDetails();
  }
  
  
  getClientFilePostageDetails()
  {
    this.spinnerService.start();
    this.reportService.getClientFilesPostageTrackingReportList(this.client).pipe(first()).subscribe(data => {
      this.http.get('assets/data/client_files_postage_tracing_report.json').subscribe(results => {
        this.dataGapCol = results;
        if (data) {
          this.dataGapList = data;
        }  
    });
    this.spinnerService.stop();
  });
}

  searchClick(show) {
    if (show == false) {
      this.toggleClass = 'fa fa-angle-double-down';
    } else {
      this.toggleClass = 'fa fa-angle-double-up';
    }
  }
  
  bindClientSubscriptionsInfo() {
    this.spinnerService.start();
    this.getClientFilePostageDetails();
    
}

// getClients(){
//   this.dealerService.getClients().pipe(first()).subscribe(clients => {
//       this.clients  = clients;
//   });

// }
ClientFilePostageDetailsExport() {
  this.spinnerService.start();
  // this.reportService.getClientFilesPostageTrackingReportList(this.client).pipe(first()).subscribe(data => {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.dataGapList);
      const workbook = { Sheets: { 'Data': worksheet }, SheetNames: ['Data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "ClientFilePostageDetails_"+''+this.client);
    });
  // });
}

saveAsExcelFile(buffer: any, fileName: string): void {
  import("file-saver").then(FileSaver => {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });

    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  });
  this.spinnerService.stop();
}
}